/* ==========================================
   collection.js — Filtros, ordenamiento, paginación AJAX
   Storefront Filtering API nativa de Shopify.
   Dependencias: theme.js (debounce, trapFocus, showOverlay, hideOverlay)
   ========================================== */

(function() {
  var section = document.querySelector('[data-collection-section]');
  if (!section) return;

  var sectionId = section.dataset.sectionId;
  var grid = section.querySelector('[data-collection-grid]');
  var filterForm = section.querySelector('[data-filter-form]');
  var sortSelect = section.querySelector('[data-sort-select]');
  var activeFiltersContainer = section.querySelector('[data-active-filters]');
  var clearAllBtn = section.querySelector('[data-clear-filters]');
  var resultsCount = section.querySelector('[data-results-count]');
  var paginationContainer = section.querySelector('[data-collection-pagination]');
  var filterDrawer = section.querySelector('[data-filter-drawer]');
  var filterDrawerToggle = section.querySelector('[data-filter-drawer-toggle]');
  var filterDrawerClose = section.querySelector('[data-filter-drawer-close]');
  var releaseFocusFn = null;

  /* ---- Filter form submission ---- */
  if (filterForm) {
    filterForm.addEventListener('input', debounce(function() {
      fetchAndUpdate();
    }, 500));

    filterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      fetchAndUpdate();
    });
  }

  /* ---- Sorting ---- */
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      fetchAndUpdate();
    });
  }

  /* ---- Build URL from form + sort ---- */
  function buildUrl() {
    var url = new URL(window.location.href);
    var params = new URLSearchParams();

    /* Collect filter inputs */
    if (filterForm) {
      var formData = new FormData(filterForm);
      var entries = formData.entries();
      var entry = entries.next();
      while (!entry.done) {
        var key = entry.value[0];
        var val = entry.value[1];
        if (val !== '' && val !== undefined) {
          params.append(key, val);
        }
        entry = entries.next();
      }
    }

    /* Sort */
    if (sortSelect && sortSelect.value) {
      params.set('sort_by', sortSelect.value);
    }

    url.search = params.toString();
    return url.toString();
  }

  /* ---- Fetch and replace ---- */
  function fetchAndUpdate(url) {
    if (!url) url = buildUrl();

    section.classList.add('is-loading');

    /* Update browser URL */
    history.pushState({}, '', url);

    /* Fetch section rendering */
    var fetchUrl = url + (url.includes('?') ? '&' : '?') + 'sections=' + sectionId;

    fetch(fetchUrl)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data[sectionId];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        /* Replace grid */
        var newGrid = doc.querySelector('[data-collection-grid]');
        if (newGrid && grid) {
          grid.innerHTML = newGrid.innerHTML;
        }

        /* Replace active filters */
        var newActive = doc.querySelector('[data-active-filters]');
        if (newActive && activeFiltersContainer) {
          activeFiltersContainer.innerHTML = newActive.innerHTML;
          bindRemoveFilterButtons();
        }

        /* Replace results count */
        var newCount = doc.querySelector('[data-results-count]');
        if (newCount && resultsCount) {
          resultsCount.innerHTML = newCount.innerHTML;
        }

        /* Replace pagination */
        var newPagination = doc.querySelector('[data-collection-pagination]');
        if (newPagination && paginationContainer) {
          paginationContainer.innerHTML = newPagination.innerHTML;
          bindPaginationLinks();
        }

        /* Replace filter form (to update counts, checked states) */
        var newFilterForm = doc.querySelector('[data-filter-form]');
        if (newFilterForm && filterForm) {
          filterForm.innerHTML = newFilterForm.innerHTML;
        }

        /* Update sort select */
        var newSort = doc.querySelector('[data-sort-select]');
        if (newSort && sortSelect) {
          sortSelect.value = newSort.value;
        }
      })
      .catch(function(err) {
        console.error('Collection fetch error:', err);
        /* Fallback: full page navigation */
        window.location.href = url;
      })
      .finally(function() {
        section.classList.remove('is-loading');
        /* Scroll to top of grid */
        var gridTop = grid ? grid.getBoundingClientRect().top + window.scrollY - 100 : 0;
        window.scrollTo({ top: gridTop, behavior: 'smooth' });
      });
  }

  /* ---- Active filter remove buttons ---- */
  function bindRemoveFilterButtons() {
    var removeBtns = section.querySelectorAll('[data-remove-filter]');
    removeBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var url = btn.dataset.removeFilter || btn.href;
        if (url) fetchAndUpdate(url);
      });
    });
  }

  /* ---- Clear all filters ---- */
  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var url = clearAllBtn.dataset.clearUrl || clearAllBtn.href;
      if (url) fetchAndUpdate(url);
    });
  }

  /* ---- Pagination links (AJAX) ---- */
  function bindPaginationLinks() {
    var paginationLinks = section.querySelectorAll('[data-collection-pagination] a');
    paginationLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        fetchAndUpdate(link.href);
      });
    });
  }

  /* ---- Price range inputs ---- */
  function initPriceRange() {
    var priceMin = section.querySelector('[data-price-min]');
    var priceMax = section.querySelector('[data-price-max]');
    if (priceMin) {
      priceMin.addEventListener('change', debounce(function() { fetchAndUpdate(); }, 500));
    }
    if (priceMax) {
      priceMax.addEventListener('change', debounce(function() { fetchAndUpdate(); }, 500));
    }
  }

  /* ---- Mobile filter drawer ---- */
  function openFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.hidden = false;
    filterDrawer.classList.add('is-open');
    showOverlay();
    releaseFocusFn = trapFocus(filterDrawer);
    if (filterDrawerToggle) filterDrawerToggle.setAttribute('aria-expanded', 'true');
  }

  function closeFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.classList.remove('is-open');
    filterDrawer.hidden = true;
    hideOverlay();
    if (releaseFocusFn) { releaseFocusFn(); releaseFocusFn = null; }
    if (filterDrawerToggle) {
      filterDrawerToggle.setAttribute('aria-expanded', 'false');
      filterDrawerToggle.focus();
    }
  }

  if (filterDrawerToggle) {
    filterDrawerToggle.addEventListener('click', function() {
      if (filterDrawer.hidden) { openFilterDrawer(); }
      else { closeFilterDrawer(); }
    });
  }

  if (filterDrawerClose) {
    filterDrawerClose.addEventListener('click', closeFilterDrawer);
  }

  if (filterDrawer) {
    filterDrawer.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeFilterDrawer();
    });
  }

  document.addEventListener('drawer:close', closeFilterDrawer);

  /* ---- Browser back/forward ---- */
  window.addEventListener('popstate', function() {
    fetchAndUpdate(window.location.href);
  });

  /* ---- Init ---- */
  bindRemoveFilterButtons();
  bindPaginationLinks();
  initPriceRange();

})();
